export const getFormatTime = currentTime => {
  let minutesString;
  let secondsString;

  // Obtener los minutos
  const minutes = Math.floor(currentTime / 60);
  if (minutes < 10) {
    minutesString = minutes.toString().padStart(2, "0");
  } else {
    minutesString = minutes;
  }

  // Obtener los segundos
  const seconds = Math.floor(currentTime % 60);

  // Añadir un 0 antes de los segundos si es menor a 10
  if (seconds < 10) {
    // seconds = '0' + seconds.toString();
    secondsString = seconds.toString().padStart(2, "0");
    // seconds = Number(seconds.toString().padStart(2, '0'));
  } else {
    secondsString = seconds;
  }

  // Formatear en mm:ss
  return `${minutesString}:${secondsString}`;
  // return `${minutes}:${seconds}`;
};
